module.exports = __webpack_public_path__ + "static/fontface-88d1a95ab67710cb6172a3980b3d8038.png";